import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { HR, errText } from "@/lib/hr";

export function DeleteEmployeeDialog({ emp, onClose }) {
  const nav = useNavigate();
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = typed.trim().toUpperCase() === emp.employee_id.toUpperCase();
  const go = async () => {
    setBusy(true);
    try {
      await axios.delete(`${HR}/employees/${emp.id}`, { params: { confirm: typed.trim() } });
      toast.success(`${emp.full_name} (${emp.employee_id}) deleted permanently`);
      nav("/hr/employees", { replace: true });
    } catch (er) { toast.error(errText(er, "Could not delete")); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0F1420] border-rose-500/30 text-slate-100 sm:max-w-md" data-testid="emp-delete-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-rose-200 flex items-center gap-2"><Trash2 className="w-4 h-4" /> Delete employee record</DialogTitle>
          <DialogDescription className="text-slate-400">This permanently removes <b className="text-slate-200">{emp.full_name}</b> and every HR record linked to them — compensation, leave, attendance, documents, ID card, insurance, contacts and history. This cannot be undone. Use <b className="text-slate-200">Resign</b> instead if the person actually worked here.</DialogDescription>
        </DialogHeader>
        <label className="text-xs text-slate-400 block">Type <span className="font-mono-num text-orange-200">{emp.employee_id}</span> to confirm
          <input value={typed} onChange={(ev) => setTyped(ev.target.value)} placeholder={emp.employee_id} autoFocus data-testid="emp-delete-confirm-input" className="mt-1 w-full h-10 rounded-lg bg-slate-950/60 border border-white/[0.08] px-3 text-sm text-slate-100 font-mono-num focus:outline-none focus:border-rose-400/60" />
        </label>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={onClose} data-testid="emp-delete-cancel" className="h-9 border-slate-700 bg-transparent">Cancel</Button>
          <Button onClick={go} disabled={!ok || busy} data-testid="emp-delete-submit" className="h-9 bg-rose-600 hover:bg-rose-500 text-white font-bold disabled:opacity-40">{busy ? "Deleting…" : "Delete permanently"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
